module.exports = {"debug":true,"testing":true}